import type { Configuration, PutDashboardRequest } from '@repo/api-gw-sdk';
import {
  DeleteDashboardApi,
  GetDashboardsApi,
  ListDashboardsApi,
  PutDashboardApi,
} from '@repo/api-gw-sdk';
import { mutate } from 'swr';

import type { HttpClient } from './httpClient';

const baseUrl = '/dashboards';

const refresh = () => mutate((key) => Array.isArray(key) && key[0] === baseUrl);

export const savedDashboards = (
  httpClient: HttpClient,
  config: Configuration
) => {
  const listDashboardsApi = new ListDashboardsApi(config);
  const getDashboardsApi = new GetDashboardsApi(config);
  const putDashboardApi = new PutDashboardApi(config);
  const deleteDashboardApi = new DeleteDashboardApi(config);

  return {
    useList: (includeShared = true) =>
      httpClient.execute(
        listDashboardsApi.listDashboards.bind(listDashboardsApi),
        baseUrl,
        'list',
        includeShared
      ),
    useGet: (ids: string[]) =>
      httpClient.execute(
        getDashboardsApi.getDashboards.bind(getDashboardsApi),
        ids.length > 0 ? baseUrl : null,
        'get',
        ids
      ),
    getAsync: (ids: string[]) => getDashboardsApi.getDashboards(ids),
    put: (id: string, dashboard: PutDashboardRequest) =>
      putDashboardApi.putDashboard(id, dashboard).then((res) => {
        void refresh();
        return res;
      }),
    delete: (id: string) =>
      deleteDashboardApi.deleteDashboard(id).then(() => {
        void refresh();
      }),
  };
};
